<template>
  <Dialog title="学员详情" :visible.sync="dialogVisible" width="800px">
    <el-descriptions
      :title="infoData.name"
      direction="vertical"
      :column="1"
      size="small"
      border
    >
      <el-descriptions-item label="身份证号">{{
        infoData.idCard
      }}</el-descriptions-item>
      <el-descriptions-item label="手机号">{{
        infoData.phone
      }}</el-descriptions-item>

      <el-descriptions-item label="学习期限"
        >{{ formatDateTime(infoData.studyStartTime, "YYYY-MM-DD") }} 至
        {{
          formatDateTime(infoData.studyEndTime, "YYYY-MM-DD")
        }}</el-descriptions-item
      >
      <el-descriptions-item label="状态"
        ><el-tag :type="infoData.status === 0 ? 'success' : 'danger'">{{
          infoData.status === 0 ? "正常" : "禁用"
        }}</el-tag></el-descriptions-item
      >
    </el-descriptions>
  </Dialog>
</template>
<script>
import { getStudentInfo } from "@/api/student";
import { formatDateTime } from "@/utils/util";
export default {
  name: "StudentsDetail",
  data() {
    return {
      dialogVisible: false,
      infoData: {}
    };
  },
  methods: {
    formatDateTime,
    async open(id) {
      this.dialogVisible = true;
      const res = await getStudentInfo(id);
      this.infoData = res.data;
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/students/StudentsDetail.vue